exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-close[data-v-20a303a6]{position:absolute;bottom:145px;right:250px;z-index:990;cursor:pointer;user-select:none;-webkit-filter:drop-shadow(1.5px 6px 4px #888);filter:drop-shadow(1.5px 6px 4px #888)}.button-close.disabled[data-v-20a303a6]{display:none;pointer-events:none}.button-title[data-v-20a303a6]{font-family:Nunito;position:absolute;bottom:4px;right:34px;z-index:999;font-size:13px;text-decoration:none;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-20a303a6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonClose.vue
// module id = 73
// module chunks = 0